module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Semibold-dfc89e609e62dde183759be5b85550fb.ttf";